import logoUrl from '@/assets/landingpage/logo2.png'
import { branches } from '@/data/mayonSite'

import manifest from './manifest.cjs'

export const siteOrigin = manifest.siteOrigin

const branchKeyById = { main: 'branchMain', 'm-place': 'branchMPlace' }
const branchById = Object.fromEntries(branches.map(branch => [branch.id, branch]))
const phoneToInternational = (phoneHref) => phoneHref.replace('tel:', '')
const imageUrl = (image) => image.startsWith('http') ? image : `${siteOrigin}${image}`

const breadcrumb = (id, items) => ({
  id,
  data: {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({ '@type': 'ListItem', position: index + 1, ...item }))
  }
})

const branchJsonLd = (branch) => ({
  id: `seo-jsonld-branch-${branch.id}`,
  data: {
    '@context': 'https://schema.org',
    '@type': ['MedicalClinic', 'DiagnosticLab'],
    '@id': `${siteOrigin}/branches/${branch.id}#location`,
    name: branch.name,
    url: `${siteOrigin}/branches/${branch.id}`,
    telephone: phoneToInternational(branch.phoneHref),
    email: branch.email,
    image: imageUrl(branch.image),
    address: branch.postalAddress,
    openingHoursSpecification: branch.openingHoursSpecification,
    parentOrganization: { '@id': `${siteOrigin}/#organization` },
    hasMap: branch.mapUrl,
    areaServed: 'Quezon City'
  }
})

const branchSeo = (branch) => ({
  ...manifest.routeManifest[branchKeyById[branch.id]],
  jsonLd: [
    breadcrumb(`seo-jsonld-branch-${branch.id}-breadcrumb`, [
      { name: 'Home', item: `${siteOrigin}/` },
      { name: 'Branches', item: `${siteOrigin}/branches` },
      { name: branch.name, item: `${siteOrigin}/branches/${branch.id}` }
    ]),
    branchJsonLd(branch)
  ]
})

export const routeSeo = {
  home: {
    ...manifest.routeManifest.home,
    jsonLd: [
      {
        id: 'seo-jsonld-organization',
        data: {
          '@context': 'https://schema.org',
          '@type': ['Organization', 'MedicalOrganization'],
          '@id': `${siteOrigin}/#organization`,
          name: 'Mayon Clinical Laboratory & Medical Services',
          url: `${siteOrigin}/`,
          logo: `${siteOrigin}${logoUrl}`,
          image: manifest.socialImageUrl,
          description: manifest.routeManifest.home.description,
          telephone: '+639054790966',
          areaServed: 'Quezon City',
          location: branches.map(branch => ({ '@id': `${siteOrigin}/branches/${branch.id}#location` }))
        }
      }
    ]
  },
  about: {
    ...manifest.routeManifest.about,
    jsonLd: [
      {
        id: 'seo-jsonld-about-page',
        data: {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          '@id': `${siteOrigin}/about#webpage`,
          name: manifest.routeManifest.about.title,
          url: manifest.routeManifest.about.canonical,
          description: manifest.routeManifest.about.description,
          isPartOf: { '@type': 'WebSite', '@id': `${siteOrigin}/#website`, name: 'Mayon Clinical Laboratory & Medical Services', url: `${siteOrigin}/` },
          about: { '@id': `${siteOrigin}/#organization` }
        }
      }
    ]
  },
  packages: { ...manifest.routeManifest.packages, jsonLd: [breadcrumb('seo-jsonld-packages-breadcrumb', [{ name: 'Home', item: `${siteOrigin}/` }, { name: 'Packages', item: `${siteOrigin}/packages` }])] },
  services: { ...manifest.routeManifest.services, jsonLd: [breadcrumb('seo-jsonld-services-breadcrumb', [{ name: 'Home', item: `${siteOrigin}/` }, { name: 'Services', item: `${siteOrigin}/services` }])] },
  hmoPartners: { ...manifest.routeManifest.hmoPartners, jsonLd: [breadcrumb('seo-jsonld-hmoPartners-breadcrumb', [{ name: 'Home', item: `${siteOrigin}/` }, { name: 'HMO Partners', item: `${siteOrigin}/hmo-partners` }])] },
  branches: { ...manifest.routeManifest.branches, jsonLd: [breadcrumb('seo-jsonld-branches-breadcrumb', [{ name: 'Home', item: `${siteOrigin}/` }, { name: 'Branches', item: `${siteOrigin}/branches` }])] },
  notFound: {
    path: '*', title: 'Page Not Found | Mayon Clinical Laboratory and Medical Services', description: 'The requested Mayon Clinical Laboratory and Medical Services page could not be found. Use these links to find services, packages, branches, and contact details.', robots: 'noindex,follow', image: manifest.socialImageUrl, socialTitle: 'Page Not Found | Mayon Clinical Laboratory and Medical Services', socialDescription: 'Find your way back to Mayon Clinical Laboratory and Medical Services services, packages, branches, and contact details.', jsonLd: []
  }
}

export const getBranchSeo = (to) => {
  const branch = branchById[to.params.id]
  return branch ? branchSeo(branch) : routeSeo.notFound
}

routeSeo.branchMain = branchSeo(branchById.main)
routeSeo.branchMPlace = branchSeo(branchById['m-place'])

export const indexableRoutes = [routeSeo.home, routeSeo.about, routeSeo.packages, routeSeo.services, routeSeo.hmoPartners, routeSeo.branches, routeSeo.branchMain, routeSeo.branchMPlace]
